import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { images } from "../../data/images";
export function EstateSection() {
  return <section aria-labelledby="estate-title" className="bg-paper" data-id="element-82" data-mp="2om0kkpw7k09f">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12 lg:gap-10" data-id="element-83" data-mp="2ontuqf6152m6">
        <div className="lg:col-span-5" data-id="element-84" data-mp="2tir1tgjr11wf">
          <div className="aspect-[4/5] overflow-hidden rounded-2xl" data-id="element-85" data-mp="3haennk25lmru">
            <img src={images.harvest} alt="Récolte manuelle de la lavande" className="h-full w-full object-cover" data-id="element-86" data-mp="3m9r5tri2y5o3" />
          </div>
        </div>

        <div className="flex flex-col lg:col-span-6 lg:col-start-7" data-id="element-87" data-mp="38981ovgqjjr7">
          <h2 id="estate-title" className="font-display text-5xl leading-[1.02] tracking-tight text-ink md:text-6xl" data-id="element-88" data-mp="3cb1zmvzjq9no">
            Trois générations
            <br data-id="element-89" data-mp="1wtjdy1vnqgpc" />
            sur les coteaux d'Apt.
          </h2>
          <div className="mt-8 grid gap-6 text-base leading-relaxed text-stone md:grid-cols-2" data-id="element-90" data-mp="20xhemh0mrzki">
            <p data-id="element-91" data-mp="1tgh74zmplr23">
              Ce qui était une ferme à lavande familiale est devenu un fournisseur pour plus de 300 marques et
              laboratoires en Europe. La méthode, elle, n'a pas changé : la plante d'abord.
            </p>
            <p data-id="element-92" data-mp="22j9yf2vw62rx">
              Nous travaillons en lots maîtrisés plutôt qu'en volumes anonymes, ce qui nous permet de réserver une
              récolte pour vous et de garantir un profil constant d'une saison à l'autre.
            </p>
          </div>

          <div className="mt-auto grid gap-8 border-t border-line pt-8 sm:grid-cols-[auto_1fr] sm:items-end" data-id="element-93" data-mp="27hjpp2ehwj89">
            <p className="font-display text-[5.5rem] leading-none text-terracotta" data-id="element-94" data-mp="2m4wgb5j5tf5i">120 ha</p>
            <p className="max-w-xs pb-2 text-sm leading-relaxed text-stone" data-id="element-95" data-mp="2h6l80z8ijcpe">
              de cultures en agriculture biologique, complétés par un réseau de 18 producteurs partenaires dans un
              rayon de 60 km.
            </p>
          </div>

          <figure className="mt-12 grid grid-cols-[96px_1fr] items-center gap-6 rounded-2xl bg-cream p-5 sm:grid-cols-[120px_1fr]" data-id="element-96" data-mp="2q5oqq23rpq3d">
            <img src={images.botanicals} alt="" className="aspect-square w-full rounded-xl object-cover" data-id="element-97" data-mp="1ssopn6wmnbtp" />
            <div data-id="element-98" data-mp="1wujn20bft527">
              <blockquote className="font-display text-xl leading-snug text-ink md:text-2xl" data-id="element-99" data-mp="1wu05ikpp8iop">
                « Leur hydrolat de lavande est devenu la base de notre gamme. Même profil olfactif depuis quatre ans. »
              </blockquote>
              <figcaption className="mt-3 text-xs text-stone" data-id="element-100" data-mp="26mz48vewtpm1">Claire M., directrice R&amp;D, marque de soin bio</figcaption>
            </div>
          </figure>

          <Link to="/domaine" className="mt-8 flex items-center gap-2 self-start text-sm font-medium text-terracotta hover:text-terracotta-dark" data-id="element-101" data-mp="2gk3sr1w89x60">
            Découvrir le domaine <ArrowRightIcon className="h-4 w-4" data-id="element-102" data-mp="m59kt9e8y8km" />
          </Link>
        </div>
      </div>
    </section>;
}